<template>
  <v-expansion-panels 
    v-if="!!contract.documents"
    multiple 
    flat
    class="border"
    v-model="keepOpen" 
    >
    <v-expansion-panel>
      <v-expansion-panel-header 
        ripple 
        expand-icon="mdi-chevron-down"
        class="text-h6"
        >
        {{ $t('contract.show.panel_three.title') }}
      </v-expansion-panel-header>
      <v-expansion-panel-content class="mt-2">
        <v-list-item 
          :key="document.id"
          v-for="document in contract.documents"
          class="pl-0">
          <v-list-item-avatar>
            <v-avatar
              color="grey">
              C
            </v-avatar>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>Contrato</v-list-item-title>
            <v-list-item-subtitle>Archivo del contrato</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn 
              :href="railsBase + document.url" 
              target="_blank"
              icon>
              <v-icon>mdi-cloud-download</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-subheader
          class="px-0"
          >
          Garantías
        </v-subheader>

        <v-list-item 
          :key="guarantee.id"
          v-for="guarantee in contract.guarantees"
          class="pl-0">
          <v-list-item-avatar>
            <v-avatar
              color="grey">
              {{ guarantee.guaranteeType.charAt(0) }}
            </v-avatar>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ guarantee.guarantor.profile.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ guarantee.guaranteeType }}</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action
            class="d-flex flex-row">
            <v-btn 
              v-for="document in guarantee.documents"
              :href="railsBase + document.url" 
              target="_blank"
              icon>
              <v-icon>mdi-cloud-download</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>							
</template>

<script>
export default {
  name:"PanelThree",
  data(){
    return{
      keepOpen: [0],
    }
  },
  props: ['contract'],
  computed: {
    // backend base URL (env-driven) for served files; no trailing slash so
    // `railsBase + document.url` matches the old `'http://localhost:3000' + url`
    railsBase() {
      return (process.env.VUE_APP_RAILS_URL || "").replace(/\/$/, "");
    }
  }
}
</script>
